import { Colors } from "assets/colors";
import { styles as inputStyles } from "common/inputStyles";

export const styles: any = {
  container: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "#E9F4FF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  loginBox: {
    height: "420px",
    width: "500px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: "5px",
    padding: "4rem",
    boxShadow: "0px 4px 8px rgba(16, 24, 64, 0.08)",
    "& img": {
      height: "80px",
      width: "150px"
    }
  },
  button: {
    ...inputStyles.buttonGreen,
    padding: ".3rem 1.5rem",
    width: "100%",
    marginTop: "2rem"
  }
} 
